var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcaseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 12.7734V4.60677C4.6665 4.06429 4.6665 3.79305 4.72613 3.5705C4.88795 2.96659 5.35966 2.49488 5.96357 2.33307C6.18611 2.27344 6.45735 2.27344 6.99984 2.27344C7.54232 2.27344 7.81356 2.27344 8.0361 2.33307C8.64002 2.49488 9.11172 2.96659 9.27354 3.5705C9.33317 3.79305 9.33317 4.06429 9.33317 4.60677V12.7734M3.03317 12.7734H10.9665C11.6199 12.7734 11.9466 12.7734 12.1962 12.6463C12.4157 12.5344 12.5942 12.3559 12.706 12.1364C12.8332 11.8869 12.8332 11.5602 12.8332 10.9068V6.47344C12.8332 5.82004 12.8332 5.49335 12.706 5.24378C12.5942 5.02426 12.4157 4.84578 12.1962 4.73393C11.9466 4.60677 11.6199 4.60677 10.9665 4.60677H3.03317C2.37978 4.60677 2.05308 4.60677 1.80352 4.73393C1.58399 4.84578 1.40552 5.02426 1.29366 5.24378C1.1665 5.49335 1.1665 5.82004 1.1665 6.47344V10.9068C1.1665 11.5602 1.1665 11.8869 1.29366 12.1364C1.40552 12.3559 1.58399 12.5344 1.80352 12.6463C2.05308 12.7734 2.37978 12.7734 3.03317 12.7734Z",
    stroke: "#101828",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseIcon);
export default __webpack_public_path__ + "static/media/BriefcaseIcon.0a9f24098a9956e835d2d053c2d1ec82.svg";
export { ForwardRef as ReactComponent };